import { useCallback } from 'react';

import { useAppSelector } from 'shared/lib';

import { selectCurrentStepOpenedAt } from 'entities/scenario';

export const useGetTimeOnCurrentStep = () => {
  const pageOpenedAt = useAppSelector(selectCurrentStepOpenedAt);

  return useCallback(() => {
    if (!pageOpenedAt) {
      return 0;
    }

    return Math.floor((Date.now() - pageOpenedAt) / 1000);
  }, [pageOpenedAt]);
};
